import { includes } from 'lodash-es'

import { useUserHasPermissions } from '../../common/hooks'

import {
  BRAND_DEFINITION,
  BRAND_GATEWAY,
  DEFINE,
  MENU_DEFINITION,
  QC,
  QQA,
  RESOLVED,
} from '../constants'

const getRequiredPermission = (task, taskType, permissions) => {
  const definitionTasks = [BRAND_GATEWAY, BRAND_DEFINITION, MENU_DEFINITION]

  if (includes(definitionTasks, taskType)) {
    if (task.currentViewType === DEFINE) {
      return permissions.RESOLVE_DEFINE_VIEW
    }

    if (task.currentViewType === QC) {
      return permissions.RESOLVE_QC_VIEW
    }

    if (task.currentViewType === QQA) {
      return permissions.RESOLVE_QQA_VIEW
    }

    throw new Error('Invalid task view type')
  }

  return permissions.ASSIGN
}

const useCanUserAssignTask = (task, taskType, permissions) => {
  const requiredPermission = getRequiredPermission(task, taskType, permissions)
  const hasPermission = useUserHasPermissions(requiredPermission)

  if (!task.currentViewType) {
    return !task.isAssigned && hasPermission && task.status !== RESOLVED
  }

  return !task.isAssigned && hasPermission
}

export default useCanUserAssignTask
